export default "__VITE_ASSET__P66ovokG__"